import { Component, Input, OnInit } from '@angular/core';
import { DropdownOption, IpoLanguageService } from '@ip-only/front-end-library';
import { environment } from '../../../environments/environment';
import { DeliveryPortalAppTypes, emailSubjectOptions } from '../home.entities';

@Component({
  selector: 'app-email-section',
  templateUrl: './email-section.component.html',
  styleUrls: ['./email-section.component.scss'],
  standalone: false,
})
export class EmailSectionComponent implements OnInit {
  @Input() appOptions: DeliveryPortalAppTypes[] = [];
  constructor(private langService: IpoLanguageService) {}

  emailsSubjectOptionsList = emailSubjectOptions;
  emailAppOptions: DropdownOption[] = [];

  emailBody = '';
  selectedEmailSubject: DropdownOption;
  selecteEmailApp: DropdownOption;

  language$ = this.langService.getLanguage$();

  ngOnInit() {
    this.emailAppOptions = this.getReleasedAppsLabel();
  }

  getReleasedAppsLabel(): DropdownOption[] {
    const deliveryPortalOptions = { label: 'other', value: 'other' };
    const options = this.appOptions.map((app) => ({
      label: app.label,
      value: app.name,
    }));

    return [...options, deliveryPortalOptions];
  }

  addSelectedOption(option: DropdownOption, isEmailSubject: boolean) {
    if (isEmailSubject) {
      this.selectedEmailSubject = option;
    } else {
      this.selecteEmailApp = option;
    }
  }

  setEmailBody(input: string) {
    this.emailBody = input;
  }

  constructMailtoUrl(): string {
    const crEmail = environment.crEmail;
    const subject = this.selectedEmailSubject?.label ?? '';
    const application = this.selecteEmailApp?.label ?? '';
    const body = this.emailBody ?? '';

    const mailtoUrl = `mailto:${crEmail}?subject=${encodeURIComponent(
      subject + ' - ' + application,
    )}&body=Subject: ${encodeURIComponent(
      subject,
    )}%0D%0A%0D%0A Application: ${encodeURIComponent(
      application,
    )}%0D%0A%0D%0A${body}`;

    return mailtoUrl;
  }

  createEmailTemplate() {
    const mailToUrl = this.constructMailtoUrl();
    window.open(mailToUrl);
  }
}
